// @ts-nocheck
// GENERATED from PropelMapper/design@b27d324 — do not edit.
import * as React from "react";
// PMSegmented.tsx — PropelMapper segmented control.
// A pill track of 2–4 options; selected segment gets a white raised chip.
// Optional PropelMapper custom icon per option (window.PM_ICONS; Material ligature fallback). Tokens throughout.

const PMSEG_CSS = `
.pmseg{box-sizing:border-box;display:inline-flex;background:var(--pm-surface-variant);border-radius:var(--pm-radius-pill,999px);padding:3px}
.pmseg-btn{all:unset;box-sizing:border-box;cursor:pointer;font-family:var(--pm-font-sans);font-size:13px;font-weight:600;color:var(--pm-fg-2);padding:7px 15px;border-radius:var(--pm-radius-pill,999px);display:inline-flex;align-items:center;justify-content:center;gap:6px;transition:.12s;white-space:nowrap}
.pmseg-btn:hover{color:var(--pm-fg-1)}
.pmseg-btn .material-symbols-outlined{font-size:17px}
.pmseg-btn.is-on{background:var(--pm-surface);color:var(--pm-primary-dark);box-shadow:var(--pm-shadow-xs)}
.pmseg-btn:focus-visible{outline:none;box-shadow:var(--pm-focus-ring)}
`;
function pmsegEnsureCSS() {
  if (typeof document === "undefined" || document.getElementById("pmseg-css")) return;
  const s = document.createElement("style"); s.id = "pmseg-css"; s.textContent = PMSEG_CSS;
  document.head.appendChild(s);
}

const pmsegGlyphVars: any = { "--icon-fg": "currentColor", "--icon-accent": "currentColor" };
function pmsegGlyph(base, size, cls = "") {
  const I = (typeof window !== "undefined" && (window as any).PM_ICONS) || {};
  const name = I[base] ? base : (I[base + "-outline"] ? base + "-outline" : null);
  if (name) return <span className={"pm-icon " + cls} aria-hidden="true"
    style={Object.assign({ width: size, height: size }, pmsegGlyphVars)}
    dangerouslySetInnerHTML={{ __html: I[name] }} />;
  return <span className={"material-symbols-outlined " + cls} aria-hidden="true"
    style={{ fontSize: size, lineHeight: 1 }}>{base}</span>;
}
export function PMSegmented({ options = [], value, onChange, className = "", style = {}, ...rest }) {
  pmsegEnsureCSS();
  return (
    <div className={"pmseg" + (className ? " " + className : "")} style={style} role="tablist" {...rest}>
      {options.map((o) => {
        const v = typeof o === "string" ? o : o.value;
        const label = typeof o === "string" ? o : o.label;
        const icon = typeof o === "string" ? null : o.icon;
        return (
          <button key={v} type="button" role="tab" aria-selected={v === value}
            className={"pmseg-btn" + (v === value ? " is-on" : "")}
            onClick={() => onChange && onChange(v)}>
            {icon ? pmsegGlyph(icon, 17) : null}
            {label}
          </button>
        );
      })}
    </div>
  );
}
